import React, { useState } from 'react';
import ProductLightbox from './ProductLightbox';

const ProductGallery = ({ images = [], alt }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [openedFrom, setOpenedFrom] = useState(null);

  if (!images.length) return null;

  const openLightbox = () => {
    setOpenedFrom(document.activeElement);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    requestAnimationFrame(() => openedFrom?.focus());
  };

  return (
    <>
      <div className="space-y-4">
        <button
          type="button"
          onClick={openLightbox}
          className="block w-full rounded-2xl overflow-hidden bg-white border border-gray-100 focus:outline-none focus:ring-4 focus:ring-blue-600/30"
          aria-label="Otevřít obrázek produktu na celou obrazovku"
        >
          <img
            src={images[activeIndex]}
            alt={alt}
            className="w-full h-auto object-contain"
          />
        </button>

        {images.length > 1 && (
          <div
            className="flex gap-3 overflow-x-auto pb-2"
            aria-label="Náhledy obrázků produktu"
          >
            {images.map((image, index) => (
              <button
                key={image}
                type="button"
                onClick={() => setActiveIndex(index)}
                className={`shrink-0 w-24 h-20 rounded-xl overflow-hidden bg-white border-2 transition-colors ${
                  activeIndex === index
                    ? 'border-blue-600 ring-2 ring-blue-600/20'
                    : 'border-gray-100 hover:border-blue-300'
                }`}
                aria-label={`Zobrazit obrázek ${index + 1}`}
                aria-current={activeIndex === index ? 'true' : undefined}
              >
                <img
                  src={image}
                  alt={`${alt} – náhled ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </button>
            ))}
          </div>
        )}
      </div>

      {lightboxOpen && (
        <ProductLightbox
          images={images}
          activeIndex={activeIndex}
          onChange={setActiveIndex}
          onClose={closeLightbox}
        />
      )}
    </>
  );
};

export default ProductGallery;